/* hs-eslint ignored failing-rules */

/* eslint-disable no-prototype-builtins */
'use es6';

import { SEARCH_KEY, MINIMUM_SEARCH_LENGTH } from 'marketplace-ui-reviews/constants/ReviewsListQueries';
import { debounce } from 'ecosystem-marketplace-core/utils/debounce';
import * as ActionTypes from '../actions/ActionTypes';
import { getProfileReviews } from '../actions/ReviewActions';
import { getReviewFilters } from '../selectors/reviews';
import { debugGate } from '../utils/env';
let uiUpdated = false;
const debouncedUpdate = debounce((dispatch, ...args) => dispatch(...args));
export default (({
  dispatch,
  getState
}) => next => action => {
  // Detect external navigation, i.e. via the browser's back button
  // Prevent duplicate dispatches when the URL changes via the UI.
  if (action.type === 'storefront/filters/updateFromLocation') {
    if (uiUpdated) {
      uiUpdated = false;
      return null;
    }
  } else if (action.type === 'storefront/filters/update' || action.type === 'storefront/filters/clearFilters') {
    uiUpdated = true;
  }

  const state = getState(); // pass catalogServices through to filters slice

  if (action.type === 'storefront/filters/updateFromLocation' || action.type === 'storefront/filters/update') {
    const catalogServices = state.services.services;
    action.payload.catalogServices = catalogServices;
  }

  if (action.type === 'storefront/filters/clearFilters' || action.type === 'storefront/filters/update') {
    const isUngatedForHomepage = state.auth.gates.includes('Marketplace:Solutions:Homepage') || debugGate('Marketplace:Solutions:Homepage');

    if (action.payload) {
      action.payload.isUngatedForHomepage = isUngatedForHomepage;
    } else {
      action.payload = {
        isUngatedForHomepage
      };
    }
  }

  const result = next(action);

  if (result.type === ActionTypes.PROFILE_REVIEW_FILTERS_UPDATED) {
    const updatedFilters = getReviewFilters(state).updateFilters(result.payload);
    const searchQuery = updatedFilters.toSearchQuery();

    if (result.payload.hasOwnProperty(SEARCH_KEY.toLowerCase())) {
      const {
        search
      } = searchQuery;

      if (!search || search.length < MINIMUM_SEARCH_LENGTH) {
        searchQuery.search = undefined;
      }

      debouncedUpdate(dispatch, getProfileReviews(searchQuery));
    } else {
      dispatch(getProfileReviews(searchQuery));
    }
  }

  return result;
});